import { hotlineItem } from "@/app/config/client";
import { useClientConfigProvider } from "@/app/config/client-config-provider";
import { EventLabels } from "@/app/constants/mix-panel-enums";
import AppRoutes from "@/app/constants/routes";
import { useMixPanel } from "@/app/context/mixPanelContext";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IoIosCloseCircle } from "react-icons/io";
import { IconType } from "react-icons/lib";
import { Modal, ModalBody } from "reactstrap";
import WriteToUsModalV2 from "./WriteToUsModalV2";

const HotlineV2 = ({
  isOpen,
  handleClose,
}: {
  isOpen: boolean;
  handleClose: Function;
}) => {
  const { trackEvent } = useMixPanel();
  const [showWriteToUs, setShowWriteToUs] = useState<boolean>(false);
  const [localModalOpen, setLocalModalOpen] = useState<boolean>(isOpen);

  const { config } = useClientConfigProvider();
  const { t } = useTranslation();

  const hotlineDataArr = config?.supports?.hotlineDataArr;

  useEffect(() => {
    if (isOpen) {
      trackEvent(EventLabels.SL_Hotline, { screen: "Support" });
      trackEvent(EventLabels.SL_Hotline_Done, { screen: "Support" });
    }
  }, [isOpen]);

  return (
    <>
      <Modal
        zIndex={""}
        isOpen={localModalOpen}
        toggle={() => {
          handleClose();
        }}
        centered
        contentClassName="hotline-modal-v2"
      >
        <ModalBody>
          <div className="hotline_modal_container_v2">
            <div className="hotline_modal_header_v2">
              <div className="modal-heading-profile-support_v2">Support</div>
              <div className="modal-heading-support-close-icon">
                <IoIosCloseCircle
                  size={24}
                  onClick={() => handleClose()}
                  color="var(--colours-grayscale-400)"
                />
              </div>
            </div>
            <div className="hotline_list_container_v2">
              {hotlineDataArr?.map((item: hotlineItem, index: number) => (
                <HotlineDataV2
                  key={index}
                  value={item.value}
                  label={item.label}
                  image={item.image}
                  index={index}
                  href={item.href}
                  cta={item.cta}
                  labelTKey={item.labelTKey}
                  handleClose={handleClose}
                  toggleWriteToUs={() => {
                    setLocalModalOpen(false);
                    setShowWriteToUs(true);
                  }}
                  ReactIcon={item?.ReactIcon}
                />
              ))}
            </div>
          </div>
        </ModalBody>
      </Modal>
      <WriteToUsModalV2
        isOpen={showWriteToUs}
        handleClose={() => {
          setShowWriteToUs(false);
          handleClose();
        }}
      />
    </>
  );
};

export default HotlineV2;

const HotlineDataV2 = ({
  value,
  label,
  labelTKey,
  image,
  index,
  href,
  cta,
  handleClose,
  toggleWriteToUs,
  ReactIcon,
}: {
  value: string;
  label: string;
  image: string;
  index: number;
  labelTKey?: string;
  href: string | null;
  cta?: string;
  handleClose?: Function;
  toggleWriteToUs: Function;
  ReactIcon?: IconType;
}) => {
  const { trackEvent } = useMixPanel();
  const { getImagePath } = useClientConfigProvider();
  const { t } = useTranslation();
  const router = useRouter();
  console.log("ReactIcon:", ReactIcon);

  return (
    <>
      <div
        // href={href ? `${href}${value}` : ""}
        key={index}
        role="button"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          textDecoration: "none",
          cursor: label === "Working hours" ? "default" : "pointer",
        }}
        onClick={() => {
          if (cta == EventLabels.CTA_FAQ) {
            router.push(AppRoutes.faq);
            handleClose?.();
          } else if (cta == EventLabels.CTA_WriteUs) {
            toggleWriteToUs(true);
          } else {
            if (href) {
              window.location.href = `${href}${value}`;
            }
            handleClose?.();
          }
          cta && trackEvent(cta, { screen: "Hotline" });
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "20px",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "46px",
              height: "46px",
              borderRadius: "8px",
              backgroundColor: "#ffffff",
              display: "flex",
              paddingLeft: "9px",
              paddingTop: "11px",
            }}
          >
            {ReactIcon ? (
              <ReactIcon
                color={"var(--SyleTokens-Color-Greyscale-Text-Subtitle)"}
                // className="navigation_btn_icon"
                fontSize={"24"}
              />
            ) : (
              <Image
                style={{ margin: "auto" }}
                src={getImagePath(image)}
                alt={""}
                width={"20"}
                height={"20"}
              />
            )}
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "5px",
              alignItems: "start",
            }}
          >
            <div className="hotline-value-v2">
              {t("hotline." + labelTKey, label)}
            </div>
            <div className="hotline-type-v2">
              {t("hotline." + value, value)}
            </div>
          </div>
        </div>
        <div
          className={`hotline_redirection_arrow ${
            label === `Working hours` && "d-none"
          }`}
        >
          {/* <FaAngleRight size={14} color="var(--color-grayscale-text-caption)" /> */}
          <Image
            src={"/common-images/right-arrow-black.png"}
            alt={""}
            width={"10"}
            height={"20"}
            className="support-go-to-arrow"
          />
        </div>
      </div>
    </>
  );
};
